export function getCsrfToken(): string | null {
  if (typeof document === 'undefined') return null
  try {
    const match = document.cookie
      .split('; ')
      .find((row) => row.startsWith('XSRF-TOKEN='))
    if (!match) return null
    const encoded = match.substring('XSRF-TOKEN='.length)
    return decodeURIComponent(encoded)
  } catch {
    return null
  }
}
